const virtualOutputComponentProvider = require("../../../../../../utils/virtualOutputComponentProvider");
const {apiV2CryptoWalletsList, apiV2CryptoWalletToggle} = require("../../../../../../api/merchant/cryptoWallet");
const {DisplayAddressMerchant} = require("../../../../../dumb/DisplayData");
const MenuForItem = require("../../../../../dumb/Menu/ForItem");
const Col = require("../../../../../dumb/Col/C");
const React = require("react");


module.exports = (request) => virtualOutputComponentProvider({
  rowHeight: 114,
  request,
  requestWrapper(self, request, params) {
    return request({...params, app_id: self.props.appId});
  },
  wrapper(render, setState, self) {
    function Item(props) {
      const {
        data,
      } = props;

      return (
        <div
          className={`w h layoutRow fhaS fvaC  rlv lh fw7 f16 c2 tc lts0em
          ph20 (ph10|w1/4)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
          aria-rowindex={props.index}
        >
          <div aria-colindex="0">{self.props.cryptoNames[data.cc_code]}</div>
          <div aria-colindex="1">{data.cc_code}</div>
          <div aria-colindex="2">
            <DisplayAddressMerchant>{data.address}</DisplayAddressMerchant>
          </div>
          <div aria-colindex="3">
            <div className={`cFFBF43.inactive c2CE889.active ${data.enabled ? 'active' : 'inactive'}`}>
              {data.enabled ? 'Active' : 'Inactive'}
            </div>
            <MenuForItem items={[
              {
                name: data.enabled ? 'Deactivate' : 'Activate',
                onClick() {
                  apiV2CryptoWalletToggle({
                    wallet_id: data.id,
                    enabled: !data.enabled
                  }).then(() => self.update());
                },
              },
              // {
              //   name: 'Delete',
              //   className: 'cE70F0F*2',
              //   onClick() {
              //     if (data.primary) {
              //       const msg = (<div>
              //         <p>Company should have at least one bank account marked as &quot;Primary&quot;</p>
              //         <p>Set/Add another bank account as &quot;primary&quot; and try again.</p>
              //       </div>);
              //       openPopupInfo(['Error', msg]);
              //       return;
              //     }
              //     openPopupDeleteCryptoAccount(data, () => {
              //       setState({
              //         loading: false,
              //         data: {
              //           ...self.state.data,
              //           list: filter(self.state.data.list, (v) => v.id !== data.id),
              //         },
              //       });
              //     });
              //   },
              // },
            ]}/>
          </div>
        </div>
      );
    }


    return (state, props) => {
      return (
        <div
          className={'mb-70 ov ovxA ' + (props.className || '')}
          data-testid="tableCryptoWallets"
        >
          <div className="wmin600">
            <div className="bg717275 layoutRow fhaC fvaC ov ph20 w1/4>1">
              <Col>Network</Col>
              <Col>Coin</Col>
              <Col>Crypto Address</Col>
              <Col>Status</Col>
            </div>
            <div className="hmin340 h100vh-510 ov c0>.CircularProgress">
              {render(Item)}
            </div>
          </div>
        </div>
      );
    };
  },
});
